(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.add('always-fixed');
				if (this.headerOverlay) {
					this.headerOverlay.classList.add('color-background-1');
					this.headerOverlay.classList.remove('color-inverse');
				}
			};

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				this.headerOverlay.classList.add('color-inverse');
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);

	document.addEventListener('DOMContentLoaded', function() {
		const addonModal = document.getElementById('AddonProductsModal');
		if (!addonModal) {
			console.error('Addon modal not found in the DOM');
			return;
		}

		console.log('Addon popup script initialized');
		
		const addonContainer = document.getElementById('AddonInfiniteOptionsContainer');
		const addToCartTriggers = document.querySelectorAll('.js-addon-trigger');
		const closeButton = addonModal.querySelector('.addon-popup-modal__close-button');
		const proceedToCartButton = addonModal.querySelector('.js-proceed-to-cart');
		
		// Product info elements
		const productImage = document.getElementById('AddonProductImage');
		const productTitle = document.getElementById('AddonProductTitle');
		const productPrice = document.getElementById('AddonProductPrice');
		const productVariant = document.getElementById('AddonProductVariant');
		
		console.log('Found Add to Cart triggers:', addToCartTriggers.length);
		
		// Close modal when clicking the close button
		if (closeButton) {
			closeButton.addEventListener('click', closeAddonModal);
		}
		
		// Close modal when clicking outside the content
		addonModal.addEventListener('click', function(event) {
			if (event.target === addonModal) {
				closeAddonModal();
			}
		});
		
		// Close modal when pressing ESC key
		document.addEventListener('keydown', function(event) {
			if (event.key === 'Escape' && addonModal.classList.contains('active')) {
				closeAddonModal();
			}
		});
		
		// Handle Add to Cart button click
		addToCartTriggers.forEach(trigger => {
			trigger.addEventListener('click', function(event) {
				event.preventDefault();
				console.log('Add to Cart button clicked');
				
				// Get the product form
				const productForm = this.closest('product-form');
				if (!productForm) {
					console.error('Product form not found');
					return;
				}
				
				// Update product information in the modal
				updateProductInfo();
				
				// Always show the modal first
				openAddonModal();
				
				// Find and move Infinite Options to the modal if it exists
				// const infiniteOptionsExists = moveInfiniteOptionsToModal();
				
				// If no Infinite Options, just show a basic message
				// if (!infiniteOptionsExists) {
				// 	console.log('No Infinite Options found, showing basic message');
				// 	addonContainer.innerHTML = '<p>No customization options available for this product. Click "Add to Cart" to continue.</p>';
				// }
			});
		});
		
		// Handle Proceed to Cart button click
		if (proceedToCartButton) {
			proceedToCartButton.addEventListener('click', function() {
				console.log('Proceed to Cart button clicked');
				const productForm = document.querySelector('product-form');
				if (!productForm) {
					console.error('Product form not found for submission');
					return;
				}
				
				// Get the form element within the product-form component
				const form = productForm.querySelector('form');
				if (!form) {
					console.error('Form element not found for submission');
					return;
				}
				
				// Ensure any selected options from the modal are synced back to the form
				syncOptionsToForm();
				
				// Submit the form
				console.log('Submitting form');
				form.submit();
				
				// Close the modal
				closeAddonModal();
			});
		} else {
			console.error('Proceed to Cart button not found');
		}
		
		/**
		 * Updates the product information in the modal
		 */
		function updateProductInfo() {
			try {
				const variantSelect = document.querySelector('[name="id"]');
				if (!variantSelect) {
					console.error('Variant select not found');
					return;
				}
				
				// Get the selected variant ID
				const selectedVariantId = variantSelect.value;
				console.log('Selected variant ID:', selectedVariantId);
				
				// Find the product JSON element
				const productSection = document.querySelector('.product');
				if (!productSection) {
					console.error('Product section not found');
					return;
				}
				
				const productJsonId = 'ProductJson-' + productSection.dataset.section;
				const productJsonElement = document.getElementById(productJsonId);
				
				if (!productJsonElement) {
					console.error('Product JSON element not found:', productJsonId);
					// Try to find product info another way
					if (productImage) productImage.src = document.querySelector('.product__media img')?.src || '';
					if (productTitle) productTitle.textContent = document.querySelector('.product__title')?.textContent || 'Product';
					// if (productPrice) productPrice.textContent = document.querySelector('.price--product')?.textContent || '';
					return;
				}
				
				// Parse the product JSON
				const productJson = JSON.parse(productJsonElement.textContent);
				console.log('Product data loaded');
				
				// Find the selected variant
				const selectedVariant = productJson.variants.find(variant => variant.id.toString() === selectedVariantId.toString());
				if (!selectedVariant) {
					console.error('Selected variant not found in product data');
					return;
				}
				
				// Set product image
				if (productImage) {
					if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
						productImage.src = selectedVariant.featured_image.src;
					} else if (productJson.featured_image) {
						productImage.src = productJson.featured_image;
					} else {
						// Try to get image from the DOM
						const firstProductImage = document.querySelector('.product__media img');
						if (firstProductImage) {
							productImage.src = firstProductImage.src;
						}
					}
				}
				
				// Set product title
				if (productTitle) {
					productTitle.textContent = productJson.title;
				}
				
				// Set product price
				// if (productPrice) {
				// 	try {
				// 		const formatter = new Intl.NumberFormat('en-US', {
				// 			style: 'currency',
				// 			currency: Shopify.currency ? Shopify.currency.active : 'USD'
				// 		});
				// 		const formattedPrice = formatter.format(selectedVariant.price / 100);
				// 		productPrice.textContent = `Regular price ${formattedPrice}`;
				// 	} catch (e) {
				// 		console.error('Error formatting price:', e);
				// 		// Fallback to basic price format
				// 		productPrice.textContent = `Regular price $${(selectedVariant.price / 100).toFixed(2)}`;
				// 	}
				// }
				
				// Set variant info if applicable
				if (productVariant) {
					if (productJson.variants.length > 1) {
						let variantInfo = [];
						
						if (selectedVariant.option1) variantInfo.push(selectedVariant.option1);
						if (selectedVariant.option2) variantInfo.push(selectedVariant.option2);
						if (selectedVariant.option3) variantInfo.push(selectedVariant.option3);
						
						productVariant.textContent = variantInfo.join(' / ');
					} else {
						productVariant.textContent = '';
					}
				}
			} catch (error) {
				console.error('Error updating product info:', error);
			}
		}
		
		/**
		 * Checks if Infinite Options app block exists in the product page
		 * @returns {boolean} true if Infinite Options exists
		 */
		function checkInfiniteOptionsExists() {
			// Look for different possible selectors for Infinite Options
			const infiniteOptionsSelectors = [
				// Official app block
				'[data-block-handle*="infinite-options"]',
				// Possible div IDs
				'#infiniteoptions-container',
				// Custom container class
				'.spb-productoptionstextdiv',
				// General Bold app elements
				'.bold_option_product_info',
				// Any element with "infinite options" in its attributes
				'[class*="infinite-options"]',
				'[id*="infinite-options"]'
			];
			
			// Check each selector
			for (const selector of infiniteOptionsSelectors) {
				const element = document.querySelector(selector);
				if (element) {
					console.log('Found Infinite Options with selector:', selector);
					return true;
				}
			}
			
			console.log('No Infinite Options found on page');
			return false;
		}
		
		/**
		 * Opens the addon products modal
		 */
		function openAddonModal() {
			document.body.classList.add('overflow-hidden');
			addonModal.classList.add('active');
		}
		
		/**
		 * Closes the addon products modal
		 */
		function closeAddonModal() {
			document.body.classList.remove('overflow-hidden');
			addonModal.classList.remove('active');
		}
		
		/**
		 * Moves Infinite Options app block content to the modal
		 * @returns {boolean} true if Infinite Options was found and moved
		 */
		function moveInfiniteOptionsToModal() {
			// Clear previous content
			addonContainer.innerHTML = '';
			
			// Try to find the Infinite Options content using various possible selectors
			const infiniteOptionsSelectors = [
				// Official app block
				'[data-block-handle*="infinite-options"]',
				// Possible div IDs
				'#infiniteoptions-container',
				// Custom container class
				'.bold_option_product_info',
				// Any element containing options
				'.spb-productoptionstextdiv',
				// The specific app block ID from the product.json
				'[data-block-handle="infinite_options_app_block_6ctGLh"]'
			];
			
			let infiniteOptionsEl = null;
			
			// Try each selector until we find a match
			for (const selector of infiniteOptionsSelectors) {
				const el = document.querySelector(selector);
				if (el) {
					console.log('Found Infinite Options element with selector:', selector);
					infiniteOptionsEl = el;
					break;
				}
			}
			
			if (infiniteOptionsEl) {
				// Clone the infinite options element
				const clonedOptions = infiniteOptionsEl.cloneNode(true);
				
				// Add the cloned options to the modal
				addonContainer.appendChild(clonedOptions);
				
				// Remove the original Infinite Options element from its original location
				// infiniteOptionsEl.parentNode.removeChild(infiniteOptionsEl);
				
				// Make sure any event listeners are preserved
				// This might be needed depending on how the app initializes
				if (typeof BOLD !== 'undefined' && BOLD.options) {
					try {
						console.log('Reinitializing BOLD options');
						BOLD.options.app.boot();
					} catch (e) {
						console.error('Error initializing BOLD options:', e);
					}
				}
				
				return true;
			} else {
				console.log('No Infinite Options elements found to move to modal');
				return false;
			}
		}
		
		/**
		 * Synchronizes options from modal back to the product form
		 */
		function syncOptionsToForm() {
			const form = document.querySelector('product-form form');
			if (!form) return;
			
			// Find all form inputs in the modal
			const modalInputs = addonContainer.querySelectorAll('input, select, textarea');
			
			modalInputs.forEach(input => {
				const name = input.getAttribute('name');
				const value = input.value;
				
				if (name) {
					// Check if this input already exists in the form
					let formInput = form.querySelector(`[name="${name}"]`);
					
					if (formInput) {
						// Update existing input
						formInput.value = value;
					} else {
						// Create a new hidden input for the form
						const hiddenInput = document.createElement('input');
						hiddenInput.type = 'hidden';
						hiddenInput.name = name;
						hiddenInput.value = value;
						form.appendChild(hiddenInput);
					}
				}
			});
		}
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
